/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersemaillabel2Inputs */

const en_partnersemaillabel2 = /** @type {(inputs: Partnersemaillabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact e-mail (optional)`)
};

const de_partnersemaillabel2 = /** @type {(inputs: Partnersemaillabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt-E-Mail (optional)`)
};

/**
* | output |
* | --- |
* | "Contact e-mail (optional)" |
*
* @param {Partnersemaillabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersemaillabel2 = /** @type {((inputs?: Partnersemaillabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersemaillabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersemaillabel2(inputs)
	return de_partnersemaillabel2(inputs)
});
export { partnersemaillabel2 as "partnersEmailLabel" }